import React, { useState, useRef, useCallback, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {
  selectFilteredParts,
  selectPartFilterVisible,
  selectPartLoading,
  selectfetchPartLoading
} from './store/selectors';
import VirtualList from '../components/VirtualList'; // Import VirtualList
import LoadingSpinner from '../../InitialPage/Sidebar/LoadingSpinner'; // Import LoadingSpinner
import { isHeaderVisible } from 'Core/redux/main/selectors';
import { MODAL_TYPES } from 'Feature/components/app-modals';
import { showModal } from 'Core/redux/main/slice';
import { Edit, Trash2, Printer } from 'react-feather';
import { Button, ButtonGroup } from 'react-bootstrap';
import { deletePart} from './store/slice';
import { actions as partActions, getPartDetailsById, getPartDetailsByIdForPrint } from './store/slice';
import { actions as productionActions, getPrinters } from '../production/store/slice';

const { setProduct } = partActions;
const { setProduct: setProductionProduct } = productionActions;

const { PARTS_ADD_EDIT, PARTS_PRINT } = MODAL_TYPES;

const PartTile = props => {
  const [columnCount, setColumnCount] = useState(6);
  const [columnWidth, setColumnWidth] = useState(300);
  const partTileRef = useRef(null);
  const filteredParts = useSelector(selectFilteredParts);
  const isLoading = useSelector(selectPartLoading);
  const filterVisible = useSelector(selectPartFilterVisible);
  const headerVisible = useSelector(isHeaderVisible);
  const isFetchDataLoading = useSelector(selectfetchPartLoading);


  const updateColumnSettings = useCallback(() => {
    if (partTileRef.current) {
      const width = partTileRef.current.offsetWidth;
      let columns = 6;

      if (width < 576) {
        columns = 1; // Mobile
      } else if (width < 768) {
        columns = 3; // Tablets
      } else if (width < 992) {
        columns = 5; // Large screens
      } else {
        columns = 6; // Extra large screens
      }

      setColumnCount(columns);
      setColumnWidth(width / columns);
    }
  }, []);

  useEffect(() => {
    updateColumnSettings();
    window.addEventListener('resize', updateColumnSettings);
    return () => window.removeEventListener('resize', updateColumnSettings);
  }, [updateColumnSettings]);

  const itemData = filteredParts.map(part => <Tile part={part} />);

  return (
    <div
      className={`shipment-tile-body ${filterVisible ? 'filter-visible' : ''} ${!headerVisible ? 'header-collapsed' : ''
        }`}
      ref={partTileRef}
    >
      {(isLoading || isFetchDataLoading) && <LoadingSpinner />}
      {
        <VirtualList
          columnCount={columnCount}
          rowCount={Math.ceil(filteredParts.length / columnCount)}
          itemData={itemData}
          columnWidth={columnWidth}
          rowHeight={150} // Adjusted row height
        />
      }
    </div>
  );
};

const Tile = ({ part }) => {

  console.log('Part itemData', part);
  const dispatch = useDispatch();

  const handleEdit = e => {
    e.stopPropagation();
    dispatch(getPartDetailsById(part.id));
    // dispatch(showModal(PARTS_ADD_EDIT, part));
  };

  const handlePrint = async e => {
    e.stopPropagation();
    let detail = null;
    try {
      detail = await dispatch(getPartDetailsByIdForPrint(part.id)).unwrap();
    } catch {
      /* open print with defaults if detail load fails */
    }
    const partIdForPrint = part.partId ?? part.id;
    const processIdForPrint =
      part.processId ?? part.productionProcessId ?? part.productionId ?? 0;
    const printPayload = {
      partId: partIdForPrint,
      id: processIdForPrint,
      processId: processIdForPrint,
      partNumber: detail?.partNumber ?? part.partNumber ?? '',
      partClass:
        detail?.partClass ??
        detail?.PartClass ??
        detail?.class ??
        detail?.Class ??
        part.partClass ??
        part.PartClass ??
        part.class ??
        part.Class ??
        '',
      workTicketNumber: part.workTicketNumber ?? '',
      status:
        detail?.status ??
        detail?.Status ??
        detail?.processStatus ??
        detail?.ProcessStatus ??
        part.status ??
        '',
      quantity:
        detail?.quantity ??
        part.quantity ??
        (detail?.partsinaBox != null && String(detail.partsinaBox).trim() !== ''
          ? Number(detail.partsinaBox)
          : undefined),
      partsinaBox: detail?.partsinaBox ?? null,
    };
    dispatch(getPrinters());
    dispatch(setProductionProduct(printPayload));
    dispatch(showModal(PARTS_PRINT, printPayload));
  };

  const handleDelete = e => {
    e.stopPropagation();
    //dispatch(deletePart(part.processId));
  };

  return (
    <div key={part.id || Math.random()} className="shipment-tile ellipsis-tile">
      <div
        className={`card p-3 m-2 d-flex flex-column justify-content-between ${part.isNewlyCreated ? 'border-success' : ''}`}
        style={{
          border: '1px solid #ddd',
          borderRadius: '4px',
          boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
        }}
      >
        <div>
          <div className="tile-actions">
            <ButtonGroup size="sm">
              <Button variant="light" onClick={handleEdit}>
                <Edit size={16} />
              </Button>
              <Button variant="light" onClick={handlePrint} title="Print">
                <Printer size={16} />
              </Button>
              {/* <Button variant="light" onClick={handleDelete}>
              <Trash2 size={16} />
            </Button> */}
            </ButtonGroup>
          </div>
          <div className="d-flex justify-content-between">
            <div className="d-flex flex-row align-items-center overflow-hidden">
              <div style={{minHeight: '50px'}} className="ms-2 overflow-hidden c-details d-flex flex-column justify-content-between">
                <h6 className="mb-0 truncate-2lines" title={part.description}>{part.description} </h6>
                <div className="text-muted fa-sm lh-1">{part.partNumber}</div>
              </div>
            </div>
          </div>
        </div>
        {/* <div className="ms-2">
          <div className="mt-2 d-flex align-items-center" style={{ lineHeight: '1rem' }}>
            <h5 className="heading me-2">{part.id}</h5>
          </div>
        </div> */}

      </div>
    </div>
  );
};

export default PartTile;
